import { render, staticRenderFns } from "./ScoreAdjust.vue?vue&type=template&id=9fad5fac&"
import script from "./ScoreAdjust.vue?vue&type=script&lang=js&"
export * from "./ScoreAdjust.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports